import InputText, { CustomInputProps } from './InputText.component';

export type InputTextProps = CustomInputProps;

export default InputText;
